import React from "react";
export const About = () => {

     return (
          <div className="page">
               <h2>About page</h2>
               <p>This is the text for the about page</p>
          </div>
     )
}